const DURATION_MIN = { dinner: 90, event: 150, drinks: 120 };
const LABEL = { dinner: "Dinner", event: "Live event", drinks: "Drinks" };

const pad = (n) => String(n).padStart(2, "0");

function stopStart(plan, stop) {
  const [h, m] = (stop.time || "19:00").split(":").map(Number);
  const [y, mo, d] = plan.date.split("-").map(Number);
  return new Date(y, mo - 1, d, h, m, 0);
}

function stopEnd(plan, stop) {
  return new Date(stopStart(plan, stop).getTime() + (DURATION_MIN[stop.type] || 90) * 60000);
}

function stamp(dt) {
  return `${dt.getFullYear()}${pad(dt.getMonth() + 1)}${pad(dt.getDate())}T${pad(dt.getHours())}${pad(dt.getMinutes())}00`;
}

function utcStamp(dt) {
  return dt.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
}

function esc(s) {
  return String(s || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\r?\n/g, "\\n");
}

export function buildICS(plan) {
  const now = utcStamp(new Date());
  const events = plan.stops.map((s, i) => {
    const desc = [s.reason, s.ticket_url ? `Tickets: ${s.ticket_url}` : "", "Planned with NightOut"].filter(Boolean).join("\n");
    return [
      "BEGIN:VEVENT",
      `UID:nightout-${plan.date}-${i}-${Math.random().toString(36).slice(2)}@nightout`,
      `DTSTAMP:${now}`,
      `DTSTART:${stamp(stopStart(plan, s))}`,
      `DTEND:${stamp(stopEnd(plan, s))}`,
      `SUMMARY:${esc(`${LABEL[s.type] || "Stop"}: ${s.name}`)}`,
      `LOCATION:${esc(s.address)}`,
      `DESCRIPTION:${esc(desc)}`,
      "END:VEVENT",
    ].join("\r\n");
  });
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//NightOut//Night Out Planner//EN",
    "CALSCALE:GREGORIAN",
    `X-WR-CALNAME:${esc(`Night out in ${plan.city}`)}`,
    ...events,
    "END:VCALENDAR",
  ].join("\r\n");
}

export function downloadICS(plan) {
  const blob = new Blob([buildICS(plan)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `night-out-${plan.city.toLowerCase().replace(/\s+/g, "-")}-${plan.date}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function googleCalendarUrl(plan) {
  const stops = plan.stops;
  const start = stopStart(plan, stops[0]);
  const end = stopEnd(plan, stops[stops.length - 1]);
  const details = stops
    .map((s) => `${s.time_label} — ${LABEL[s.type] || "Stop"}: ${s.name}\n${s.address || ""}${s.ticket_url ? `\nTickets: ${s.ticket_url}` : ""}`)
    .join("\n\n");
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: `Night out in ${plan.city} · ${plan.vibe}`,
    dates: `${stamp(start)}/${stamp(end)}`,
    details: `${details}\n\nPlanned with NightOut`,
    location: stops[0]?.address || plan.city,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
